import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'fiko-sph-eleman-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzSelectModule,
    NzInputNumberModule,
    NzSliderModule,
    NzSwitchModule,
    NzCardModule,
    NzTagModule,
    NzDividerModule,
    NzFormModule,
    NzGridModule,
    NzIconModule,
    NzInputModule,
    NzModalModule
  ],
  templateUrl: './fiko-sph-eleman-panel.component.html',
  styleUrls: ['./fiko-sph-eleman-panel.component.less']
})
export class FikoSPHElemanPanelComponent implements OnChanges {
  @Input() eleman: any;
  @Output() elemanDegisti = new EventEmitter<any>();
  @Output() elemanSilindi = new EventEmitter<string>();

  // Local copy for editing
  elemanKopyasi: any = null;

  // Parameter definitions by element type
  parametreYapilari: any = {
    'dokum-girisleri': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'yonX', etiket: 'Yon X', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonY', etiket: 'Yon Y', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonZ', etiket: 'Yon Z', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'hiz', etiket: 'Hiz (m/s)', tip: 'number', min: 0, max: 10, step: 0.1 },
      { ad: 'akisHizi', etiket: 'Akis Hizi (m³/s)', tip: 'number', min: 0, max: 5, step: 0.01 },
      { ad: 'yaricap', etiket: 'Yaricap (m)', tip: 'number', min: 0.01, max: 1, step: 0.01 },
      { ad: 'kesitTipi', etiket: 'Kesit Tipi', tip: 'select', secenekler: ['daire', 'kare', 'dikdortgen'] },
      { ad: 'sicaklik', etiket: 'Sicaklik (°C)', tip: 'number', min: -50, max: 1500, step: 1 },
      { ad: 'turbulans', etiket: 'Turbulans', tip: 'slider', min: 0, max: 1, step: 0.01 },
      { ad: 'akisProfili', etiket: 'Akis Profili', tip: 'select', secenekler: ['uniform', 'parabolic', 'turbulent'] },
      { ad: 'baslamaZamani', etiket: 'Baslama Zamani (s)', tip: 'number', min: 0, max: 100, step: 0.1 },
      { ad: 'bitisZamani', etiket: 'Bitis Zamani (s)', tip: 'number', min: 0, max: 100, step: 0.1 }
    ],
    'hava-delikleri': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'yonX', etiket: 'Yon X', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonY', etiket: 'Yon Y', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonZ', etiket: 'Yon Z', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'cap', etiket: 'Cap (m)', tip: 'number', min: 0.001, max: 0.5, step: 0.001 },
      { ad: 'derinlik', etiket: 'Derinlik (m)', tip: 'number', min: 0.01, max: 2, step: 0.01 },
      { ad: 'geriBasinc', etiket: 'Geri Basinc (Pa)', tip: 'number', min: 0, max: 10000, step: 10 },
      { ad: 'direncs', etiket: 'Direncs', tip: 'slider', min: 0, max: 1, step: 0.01 },
      { ad: 'gecirgenlik', etiket: 'Gecirgenlik', tip: 'slider', min: 0, max: 1, step: 0.01 },
      { ad: 'tip', etiket: 'Tip', tip: 'select', secenekler: ['standart', 'filtreli', 'vakum'] }
    ],
    'engeller': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'yonX', etiket: 'Yon X', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonY', etiket: 'Yon Y', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonZ', etiket: 'Yon Z', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'genislik', etiket: 'Genislik (m)', tip: 'number', min: 0.01, max: 10, step: 0.01 },
      { ad: 'yukseklik', etiket: 'Yukseklik (m)', tip: 'number', min: 0.01, max: 10, step: 0.01 },
      { ad: 'derinlik', etiket: 'Derinlik (m)', tip: 'number', min: 0.01, max: 10, step: 0.01 },
      { ad: 'kalinlik', etiket: 'Kalinlik (m)', tip: 'number', min: 0.001, max: 1, step: 0.001 },
      { ad: 'gecirgenlik', etiket: 'Gecirgenlik', tip: 'slider', min: 0, max: 1, step: 0.01 },
      { ad: 'suruklenme', etiket: 'Suruklenme', tip: 'slider', min: 0, max: 1, step: 0.01 },
      { ad: 'hareketTipi', etiket: 'Hareket Tipi', tip: 'select', secenekler: ['sabit', 'donel', 'oteleme'] },
      { ad: 'donusHizi', etiket: 'Donus Hizi (rad/s)', tip: 'number', min: 0, max: 10, step: 0.1 }
    ],
    'filtreler': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'boyut', etiket: 'Boyut (m)', tip: 'number', min: 0.01, max: 5, step: 0.01 },
      { ad: 'gecirgenlik', etiket: 'Gecirgenlik', tip: 'slider', min: 0, max: 1, step: 0.01 },
      { ad: 'gozBoyutu', etiket: 'Goz Boyutu (mm)', tip: 'number', min: 0.1, max: 10, step: 0.1 },
      { ad: 'kalinlik', etiket: 'Kalinlik (m)', tip: 'number', min: 0.001, max: 0.5, step: 0.001 }
    ],
    'besleyiciler': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'hacim', etiket: 'Hacim (m³)', tip: 'number', min: 0.01, max: 10, step: 0.01 },
      { ad: 'basinc', etiket: 'Basinc (Pa)', tip: 'number', min: 0, max: 100000, step: 100 },
      { ad: 'sicaklik', etiket: 'Sicaklik (°C)', tip: 'number', min: -50, max: 1500, step: 1 }
    ],
    'cikislar': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'yonX', etiket: 'Yon X', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonY', etiket: 'Yon Y', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'yonZ', etiket: 'Yon Z', tip: 'number', min: -1, max: 1, step: 0.1 },
      { ad: 'alan', etiket: 'Alan (m²)', tip: 'number', min: 0.001, max: 10, step: 0.001 },
      { ad: 'tip', etiket: 'Tip', tip: 'select', secenekler: ['acik', 'basinc-kontrol', 'akis-kontrol'] }
    ],
    'sensorler': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'tip', etiket: 'Tip', tip: 'select', secenekler: ['basinc', 'hiz', 'sicaklik', 'densitesi', 'dolum'] },
      { ad: 'orneklemeHizi', etiket: 'Ornekleme Hizi (Hz)', tip: 'number', min: 1, max: 1000, step: 1 },
      { ad: 'yaricap', etiket: 'Yaricap (m)', tip: 'number', min: 0.001, max: 1, step: 0.001 }
    ],
    'termal': [
      { ad: 'pozisyonX', etiket: 'Pozisyon X', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonY', etiket: 'Pozisyon Y', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'pozisyonZ', etiket: 'Pozisyon Z', tip: 'number', min: -10, max: 10, step: 0.1 },
      { ad: 'tip', etiket: 'Tip', tip: 'select', secenekler: ['isitici', 'sogutma', 'yalitim'] },
      { ad: 'sicaklik', etiket: 'Hedef Sicaklik (°C)', tip: 'number', min: -200, max: 2000, step: 1 },
      { ad: 'guc', etiket: 'Guc (W)', tip: 'number', min: 0, max: 10000, step: 10 },
      { ad: 'iletkenlik', etiket: 'Iletkenlik', tip: 'slider', min: 0, max: 1, step: 0.01 }
    ]
  };

  constructor(private modal: NzModalService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eleman'] && this.eleman) {
      // Create a deep copy for editing
      this.elemanKopyasi = JSON.parse(JSON.stringify(this.eleman));
    }
  }

  getParametreler(): any[] {
    return this.parametreYapilari[this.eleman?.tip] || [];
  }

  parametreGuncelle(parametreAdi: string, deger: any): void {
    if (!this.elemanKopyasi.parametreler) {
      this.elemanKopyasi.parametreler = {};
    }
    this.elemanKopyasi.parametreler[parametreAdi] = deger;
    this.elemanDegisti.emit(this.elemanKopyasi);
  }

  adDegistir(): void {
    this.elemanDegisti.emit(this.elemanKopyasi);
  }

  aktiflikDegistir(): void {
    this.elemanDegisti.emit(this.elemanKopyasi);
  }

  klonla(): void {
    const yeniEleman = JSON.parse(JSON.stringify(this.elemanKopyasi));
    yeniEleman.id = (parseInt(this.elemanKopyasi.id) + 1000).toString();
    yeniEleman.ad = `${this.elemanKopyasi.ad} (Kopya)`;
    this.elemanDegisti.emit(yeniEleman);
  }

  sil(): void {
    this.modal.confirm({
      nzTitle: 'Eleman Sil',
      nzContent: `"${this.eleman.ad}" elemanini silmek istediginizden emin misiniz?`,
      nzOkText: 'Sil',
      nzOkDanger: true,
      nzCancelText: 'Iptal',
      nzOnOk: () => {
        this.elemanSilindi.emit(this.eleman.id);
      }
    });
  }

  getParametreDeger(parametreAdi: string): any {
    return this.elemanKopyasi?.parametreler?.[parametreAdi];
  }

  getTipEtiketi(): string {
    const etiketler: any = {
      'dokum-girisleri': 'Dokum Girisi',
      'hava-delikleri': 'Hava Deligi',
      'engeller': 'Engel',
      'filtreler': 'Filtre',
      'besleyiciler': 'Besleyici',
      'cikislar': 'Cikis',
      'sensorler': 'Sensor',
      'termal': 'Termal'
    };
    return etiketler[this.eleman?.tip] || 'Bilinmeyen';
  }
}
